import { translate } from '../../Services/translation';
import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';
import Discount from './Checkout.Discount';

const CheckoutOrderSummary = ({ className }: { className?: string }) => {
  const cart = useTypedSelector((state) => state.cart);
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );

  return (
    <div className={clsx(className, 'flex flex-col gap-4')}>
      <h4 className="md-down:hidden uppercase">
        {translate('checkout.summary.title')}
      </h4>
      <div className="flex flex-col gap-1 text-lg">
        <div className="flex justify-between">
          <span>{translate('checkout.order.sum')}</span>
          <span>{cart.orderTotal}</span>
        </div>
        {cart.discount && (
          <div className="flex justify-between text-error-500">
            <span>{translate('checkout.order.saved')}</span>
            <span>{cart.discount}</span>
          </div>
        )}
        {!userInfo?.isBusinessCustomer && cart.deliveryCost && (
          <div className="flex justify-between">
            <span>{translate('checkout.order.shipping')}</span>
            <span>{cart.deliveryCost}</span>
          </div>
        )}
        {cart.paymentCost && (
          <div className="flex justify-between">
            <span>{translate('checkout.order.fee')}</span>
            <span>{cart.paymentCost}</span>
          </div>
        )}

        <div className={clsx('flex justify-between', 'font-bold')}>
          <span>{translate('checkout.order.grand-total')}</span>
          <span>{cart.grandTotal}</span>
        </div>
        <div className="flex justify-between">
          <span>{translate('checkout.order.vat')}</span>
          <span>{cart.vat}</span>
        </div>
      </div>
      {!userInfo?.isBusinessCustomer && <Discount />}
    </div>
  );
};

export default CheckoutOrderSummary;
